import * as validation from 'gridstrap/lib/validation';

const validationTests = [{
	checkClass: 'gs-FormField--validateRequired',
	invalidClass: 'is-invalid-required',
	test: validation.required
}, {
	checkClass: 'gs-FormField--validateFullName',
	invalidClass: 'is-invalid-full-name',
	test: validation.fullName
}, {
	checkClass: 'gs-FormField--validateEmail',
	invalidClass: 'is-invalid-email',
	test: validation.email
}, {
	checkClass: 'gs-FormField--validateUrl',
	invalidClass: 'is-invalid-url',
	test: validation.url
}];

export default validationTests;
